<template>
    <div>
        <!--<button type="button" class="btn btn-primary mb-2" :disabled="loading" @click="handleAddClick">Add</button>-->
        <div class="row border-bottom">
            <div class="col-12">
                <div class="mb-2 float-right">
                    <div class="row">
                        <div class="col-xs-offset 1 col-xs-11 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
                            <div class="btn-toolbar" role="toolbar">
                                <div class="btn-group btn-group-justified" role="group">
                                    <div class="btn-group" role="group">
                                        <button id="refresh-bank-details" class="btn btn-primary" data-original-title="Refresh" @click="refresh()"><i class="fas fa-sync-alt" aria-hidden="true"></i></button>
                                        <b-tooltip target="refresh-bank-details" triggers="hover">
                                            Refresh bank details list
                                        </b-tooltip>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button id="new-bank-details" class="btn btn-primary" data-original-title="new" :disabled="isReadonly"><i class="fas fas fa-plus" aria-hidden="true" @click="handleAddClick()"></i></button>
                                        <b-tooltip target="new-bank-details" triggers="hover">
                                            Add bank details
                                        </b-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading && loading == true" class="row align-items-center justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <table v-else class="table">
            <thead>
                <tr>
                    <td colspan="9">
                        <p>Bank account should be in the name of the claimant, <strong>{{claimantName}}</strong> unless it is a business account!  If there is a <span class="badge badge-danger">Check</span> in the Name column then the account is possibly for another person / organisation.</p>
                    </td>
                </tr>
                <tr>
                    <th scope="col">Bank / Building Society Name</th>
                    <th scope="col">Name</th>
                    <th scope="col">Number</th>
                    <th scope="col">Sortcode</th>
                    <th scope="col">Business</th>
                    <th scope="col">Default</th>
                    <th scope="col">Created</th>
                    <th scope="col">Created By</th>
                    <th scope="col">Last Updated</th>
                    <th scope="col">Last Updated By</th>
                    <th scope="col">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(itm, idx) in checkedBankDetails" :key="'claimbankdetailslist_' + idx"
                    :class="selectedRowIndex == idx ? 'table-primary' : ''"
                    :style="'cursor: pointer'"
                    @click="handleRowClick(idx, itm)">
                    <td>{{itm.name}}</td>
                    <td>
                        {{getAccountName(itm)}}
                        <span v-if="itm.distance && itm.distance >= 5" class="badge badge-danger">Check</span>
                    </td>
                    <td>{{itm.accountNumber}}</td>
                    <td>{{itm.accountSortcode}}</td>
                    <td>{{formatBooleanYesNo(itm.businessAccount)}}</td>
                    <td>{{formatBooleanYesNo(itm.default)}}</td>
                    <td>{{itm.dateCreatedFormated}}</td>
                    <td>{{itm.createdByName}}</td>
                    <td>{{itm.dateLastUpdatedFormated}}</td>
                    <td>{{itm.lastUpdatedByName}}</td>
                    <td>
                        <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret :boundary="'window'">
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                <span class="sr-only">Actions menu</span>
                            </template>
                            <b-dropdown-item href="javascript:void(0)" @click="handleSetAsDefaultClick(idx,itm)" :disabled="isDefault(itm)">
                                Set as default
                            </b-dropdown-item>
                            <b-dropdown-item href="javascript:void(0)" @click="handleCopyClick(idx,itm)">
                                <i v-if="false" :class="iconClass"></i> Copy
                            </b-dropdown-item>
                            <b-dropdown-item href="javascript:void(0)" @click="handleEditClick(idx,itm)" :disabled="isReadonly">
                                <i v-if="false" :class="iconClass"></i> Edit
                            </b-dropdown-item>
                            <b-dropdown-item href="javascript:void(0)" @click="handleDeleteClick(idx,itm)" :disabled="isReadonly">
                                <i v-if="false" :class="iconClass"></i> Delete
                            </b-dropdown-item>
                        </b-dropdown>
                    </td>
                </tr>
            </tbody>
        </table>
        <b-modal :id="'claim-bank-details-edit-modal-' + $vnode.key" title="Claim Bank Details" size="lg" hide-footer>
            <div v-if="selectedItem || mode == 1">
                <div class="row mt-2">
                    <div class="col pl-4 p-2">
                        <span>Bank / Building Society Name</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="bankDetailsName" v-model="editBankDetailsModel.name">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editBankDetailsModel.validators.find(v => v.item == 'name').isValid">
                            {{editBankDetailsModel.validators.find(v => v.item == 'name').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Business Account</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <toggle-switch v-model="editBankDetailsModel.businessAccount"></toggle-switch>
                        
                    </div>
                </div>
                <div class="row" v-if="editBankDetailsModel.businessAccount">
                    <div class="col pl-4 p-2">
                        <span>Account Name</span>
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #8b8686;" v-show="claimantName">
                            Bank account should be in the name of the claimant, <strong>{{claimantName}}</strong> unless this is a business account.
                        </div>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="bankDetailsAccountName" v-model="editBankDetailsModel.accountName">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editBankDetailsModel.validators.find(v => v.item == 'accountName').isValid">
                            {{editBankDetailsModel.validators.find(v => v.item == 'accountName').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div v-if="!editBankDetailsModel.businessAccount">
                    <div class="row">
                        <div class="col pl-4 p-2">
                            <span>Account first name</span>
                            <small class="form-text text-muted">Please enter full first name, without any initial or title.</small>
                        </div>
                        <div class="col-7 border-left pl-4 p-2">
                            <input type="text" class="form-control" id="bankDetailsAccountFirstname" v-model="editBankDetailsModel.accountFirstname">
                            <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editBankDetailsModel.validators.find(v => v.item == 'accountFirstname').isValid">
                                {{editBankDetailsModel.validators.find(v => v.item == 'accountFirstname').inValidFeedback}}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col pl-4 p-2">
                            <span>Account last name</span>
                        </div>
                        <div class="col-7 border-left pl-4 p-2">
                            <input type="text" class="form-control" id="bankDetailsAccountLastname" v-model="editBankDetailsModel.accountLastname">
                            <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editBankDetailsModel.validators.find(v => v.item == 'accountLastname').isValid">
                                {{editBankDetailsModel.validators.find(v => v.item == 'accountLastname').inValidFeedback}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Account Number</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="bankDetailsAccountNumber" v-model="editBankDetailsModel.accountNumber">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editBankDetailsModel.validators.find(v => v.item == 'accountNumber').isValid">
                            {{editBankDetailsModel.validators.find(v => v.item == 'accountNumber').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Account Sortcode</span>
                        <small class="form-text text-muted">No spaces or hyphens.</small>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="bankDetailsAccountSortcode" v-model="editBankDetailsModel.accountSortcode">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editBankDetailsModel.validators.find(v => v.item == 'accountSortcode').isValid">
                            {{editBankDetailsModel.validators.find(v => v.item == 'accountSortcode').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <hr />
                <div class="float-right">
                    <button type="button" class="btn btn-secondary" :disabled="loading" @click="handleCloseClick()">Close</button>
                    <button type="button" class="btn btn-primary ml-2" :disabled="!editBankDetailsModelIsValid() || loading" @click="handleOKClick()">OK</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'

    import axios from 'axios'
    import { API_BASE_URL } from '../globalVar'

    import { required, requiredIf, numeric, minLen, maxLen } from '@/util/validators'
    import { runValidators, getValidators, getValidatorsIsValid } from '@/util/validation'

    import watchAll from '@/mixins/watchAll.js'
    import validator from '@/mixins/validator.js'

    import { calculateLevenshteinDistance } from '@/util/calculateLevenshteinDistance.js'
    import { trueFalseNotSetToYesNoUnavailable } from '@/util/formatters.js'

    import ToggleSwitch from '@/components/ToggleSwitch.vue'

    export default {
        name: 'ClaimBankDetails',
        props: {
            claimId: {
                type: Number,
                required: true
            },
            load: Boolean,
            claimantName: {
                type: String,
                required: false,
                default: () => { return null }
            }
        },
        mixins: [
            watchAll,
            validator
        ],
        components: {
            ToggleSwitch
        },
        data: () => {
            return {
                baseUrl: API_BASE_URL,
                bankDetails: [],
                selectedRowIndex: null,
                selectedItem: null,
                mode: null, // 1 add, 2 edit

                editBankDetailsModel: {
                    name: null,
                    accountName: null,
                    accountFirstname: null,
                    accountLastname: null,
                    accountNumber: null,
                    accountSortcode: null,
                    businessAccount: false,
                    validators: [
                        {
                            item: 'name',
                            validators: [
                                required
                            ],
                            isValid: false,
                            inValidFeedback: 'Required'
                        },
                        {
                            item: 'accountName',
                            validators: [
                                requiredIf('businessAccount', true)
                            ],
                            isValid: false,
                            inValidFeedback: 'Required'
                        },
                        {
                            item: 'accountFirstname',
                            validators: [
                                requiredIf('businessAccount', false)
                            ],
                            isValid: false,
                            inValidFeedback: 'Required'
                        },
                        {
                            item: 'accountLastname',
                            validators: [
                                requiredIf('businessAccount', false)
                            ],
                            isValid: false,
                            inValidFeedback: 'Required'
                        },
                        {
                            item: 'accountNumber',
                            validators: [
                                required, numeric, minLen(8), maxLen(8)
                            ],
                            isValid: false,
                            inValidFeedback: 'Required, 8 digits'
                        },
                        {
                            item: 'accountSortcode',
                            validators: [
                                required, numeric, minLen(6), maxLen(6)
                            ],
                            isValid: false,
                            inValidFeedback: 'Required, 6 digits'
                        }
                    ]
                },
                loading: false
            }
        },
        watch: {
            load: async function (newVal, oldVal) {
                if (newVal == true) {
                    await this.getBankDetailsForClaim(this.claimId)
                }
            }
        },
        computed: {
            checkedBankDetails() {                
                try {
                    if (this.bankDetails) {
                        const updatedArray = this.bankDetails.map((element) => ({
                            ...element,
                            distance: 0
                            /*distance: calculateLevenshteinDistance(this.claimantName, getAccountName(element.accountName))*/
                        }));
                        return updatedArray
                    }
                    return []
                } catch (err) {
                    return this.bankDetails
                } 
            },
            isReadonly() {
                return this.$adminUser.isReadonly();
            },
        },
        methods: {
            async refresh() {
                await this.getBankDetailsForClaim(this.claimId)
            },
            async getBankDetailsForClaim(claimId) {
                console.log('-c: ', claimId)
                if (claimId && !isNaN(claimId)) {
                    this.loading = true
                    try {
                        const response = await axios.get('/api/admin/v1/finance/bankdetails/' + claimId)
                        const { data } = response
                        console.log('-r: ', response)
                        this.bankDetails = data
                    } catch (error) {
                        console.error(error)
                    } finally {
                        this.loading = false
                        this.$emit('finished-loading')
                    }
                }
            },
            handleRowClick(rowIndex, item) {
                this.selectedRowIndex = rowIndex
            },
            handleAddClick() {
                this.selectedItem = null
                this.editBankDetailsModel.name = null
                this.editBankDetailsModel.accountName = null
                this.editBankDetailsModel.accountFirstname = null
                this.editBankDetailsModel.accountLastname = null
                this.editBankDetailsModel.accountNumber = null
                this.editBankDetailsModel.accountSortcode = null
                this.editBankDetailsModel.businessAccount = false
                this.mode = 1
                this.$bvModal.show('claim-bank-details-edit-modal-' + this.$vnode.key)
            },
            handleEditClick(rowIndex, item) {
                this.selectedItem = item
                this.editBankDetailsModel.name = item.name
                this.editBankDetailsModel.accountName = item.accountName
                this.editBankDetailsModel.accountFirstname = item.accountFirstname
                this.editBankDetailsModel.accountLastname = item.accountLastname
                this.editBankDetailsModel.accountNumber = item.accountNumber
                this.editBankDetailsModel.accountSortcode = item.accountSortcode
                this.editBankDetailsModel.businessAccount = item.businessAccount
                this.mode = 2
                this.$bvModal.show('claim-bank-details-edit-modal-' + this.$vnode.key)
            },
            handleCopyClick(idx, itm) {
                var toCopy = itm.name + ' | ' + itm.accountName + ' | ' + itm.accountNumber + ' | ' + itm.accountSortcode

                var tempInput = document.createElement("input");
                tempInput.value = toCopy;
                document.body.appendChild(tempInput);
                tempInput.select();
                try {
                    if (document.execCommand('copy')) {
                        //this.copyToPopupText = 'Copied'
                        //let self = this
                        //setTimeout(function () {
                        //    self.copyToPopupText = 'Copy to clipboard'
                        //}, 2000);
                    }

                } catch (err) {
                    console.log(err)
                }

                document.body.removeChild(tempInput);
            },
            async handleDeleteClick(rowIndex, item) {
                this.selectedItem = item

                const confirm = await this.$bvModal.msgBoxConfirm('Please confirm you want to Delete these Bank Details?')
                if (confirm != null) {
                    if (confirm == true) {
                        let { id, rv } = this.selectedItem
                        let payload = {
                            id,
                            rv
                        }

                        this.loading = true
                        try {
                            const response = await axios.post('/api/admin/v1/finance/delbankdetails/', payload)
                            const { data } = response
                            if (data) {
                                if (data.deleted == true)
                                    this.bankDetails = this.bankDetails.filter(i => i.id !== data.id)
                            }

                        } catch (error) {
                            console.error(error)
                        } finally { this.loading = false }
                    }
                }
            },
            isDefault(itm) {
                if (itm) {
                    if (itm.hasOwnProperty('default')) {
                        return itm.default;
                    }
                }
                return false;
            },
            async handleSetAsDefaultClick(rowIndex, item) {
                this.selectedItem = item
                const confirm = await this.$bvModal.msgBoxConfirm('Please confirm you want to set these Bank Details as the default for the claim?')
                if (confirm != null) {
                    if (confirm == true) {
                        let { id, rv } = this.selectedItem
                        let payload = {
                            id,
                            rv
                        }
                        this.loading = true
                        try {
                            const response = await axios.post('/api/admin/v1/finance/bankdetails/setasdefault/', payload)
                            const { data } = response
                            if (data) {
                                if (data) {
                                    console.log('-d: ', data)
                                    const idx = this.bankDetails.findIndex(obj => obj.id = data.id)
                                    this.bankDetails[idx] = data
                                }
                            }

                        } catch (error) {
                            console.error(error)
                        } finally { this.loading = false }
                    }
                }
            },
            editBankDetailsModelRunValidators() { runValidators(this.editBankDetailsModel) },
            editBankDetailsModelIsValid() { return getValidatorsIsValid(this.editBankDetailsModel) },
            async handleOKClick() {
                let { name, accountName, accountFirstname, accountLastname, accountNumber, accountSortcode, businessAccount } = this.editBankDetailsModel
                let payload = {
                    claimId: this.claimId,
                    name,
                    accountName,
                    accountNumber,
                    accountSortcode,
                    businessAccount,
                    accountFirstname,
                    accountLastname
                }
                if (this.mode == 1) {
                    this.loading = true
                    try {
                        const response = await axios.post('/api/admin/v1/finance/addbankdetails/', payload)
                        const { data } = response
                        if (data) {
                            this.bankDetails = this.bankDetails = [data, ...this.bankDetails] //.unshift(data) //.map(i => i.id !== data.id ? i : data)
                            //await this.refresh()
                            this.$bvModal.hide('claim-bank-details-edit-modal-' + this.$vnode.key)
                        }

                    } catch (error) {
                        console.error(error)
                    } finally { this.loading = false }

                } else if (this.mode == 2) {
                    let { id, rv } = this.selectedItem
                    payload.id = id
                    payload.rv = rv
                    this.loading = true
                    try {
                        const response = await axios.post('/api/admin/v1/finance/editbankdetails/', payload)
                        const { data } = response
                        if (data) {
                            //this.bankDetails = this.bankDetails.map(i => i.id !== data.id ? i : data)
                            const idx = this.bankDetails.findIndex(obj => obj.id == data.id)
                            this.bankDetails[idx] = data
                            //await this.refresh()
                            this.$bvModal.hide('claim-bank-details-edit-modal-' + this.$vnode.key)
                        }

                    } catch (error) {
                        console.error(error)
                    } finally { this.loading = false }
                } 

                await this.refresh()
            },
            async handleCreateClaimPaymentClick(idx, itm) {


                console.log('-i : ', itm)
                this.loading = true
                try {


                } catch (error) {
                    console.error(error)
                } finally { this.loading = false }
            },
            handleCloseClick() {
                this.$bvModal.hide('claim-bank-details-edit-modal-' + this.$vnode.key)
                this.selectedItem = null
                //this.editAmountModel.net = 0
                //this.editAmountModel.tax = 0
                //this.editAmountModel.gross = 0
            },
            formatBooleanYesNo(value) {
                return trueFalseNotSetToYesNoUnavailable(value);
            },
            getAccountName(itm) {
                if (itm.accountName) {
                    return itm.accountName
                } else {
                    return `${itm.accountFirstname} ${itm.accountLastname}`
                };
            }
        },
        async mounted() {
            this.watchAll(['editBankDetailsModel.name', 'editBankDetailsModel.accountName', 'editBankDetailsModel.accountFirstname', 'editBankDetailsModel.accountLastname', 'editBankDetailsModel.accountNumber', 'editBankDetailsModel.accountSortcode'],
                this.editBankDetailsModelRunValidators.bind(this))

        }
    }
</script>